import React, { useState } from "react";
import { Play, Headphones, Youtube, Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const fmt = (s) => {
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}m ${sec.toString().padStart(2, "0")}s`;
};

const RuqyahRecommendation = ({ videos = [] }) => {
  const [playing, setPlaying] = useState(null);
  const { t, lang } = useLanguage();

  if (!videos || videos.length === 0) return null;

  return (
    <section
      data-testid="ruqyah-recommendation"
      className="clay-surface-soft rounded-3xl p-7 sm:p-8 mb-8"
    >
      <div className="flex items-center gap-3 mb-2">
        <Headphones className="w-5 h-5 text-gold" />
        <h2 className="font-heading text-2xl text-forest font-semibold">
          {t("ruqyah_rec_title")}
        </h2>
      </div>
      <p className="text-sm text-mute leading-relaxed mb-6">
        {t("ruqyah_rec_subtitle")}
      </p>

      <div className="grid sm:grid-cols-2 gap-4">
        {videos.map((v) => {
          const isPlaying = playing === v.id;
          return (
            <div
              key={v.id}
              data-testid={`rec-video-${v.id}`}
              className="rounded-2xl overflow-hidden bg-white border border-forest/10"
            >
              <div className="relative aspect-video bg-forest/10">
                {isPlaying ? (
                  <iframe
                    src={`https://www.youtube.com/embed/${v.id}?autoplay=1&rel=0`}
                    title={v.title_en}
                    className="absolute inset-0 w-full h-full"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <button
                    data-testid={`rec-play-${v.id}`}
                    onClick={() => setPlaying(v.id)}
                    className="absolute inset-0 group"
                    aria-label="Play"
                  >
                    <img
                      src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`}
                      alt={v.title_en}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition flex items-center justify-center">
                      <div className="w-12 h-12 rounded-full bg-sand/90 group-hover:bg-gold text-forest group-hover:text-sand flex items-center justify-center transition-all">
                        <Play className="w-5 h-5 ml-0.5" fill="currentColor" />
                      </div>
                    </div>
                    <div className="absolute top-2 right-2 bg-black/70 text-sand text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1">
                      <Clock className="w-2.5 h-2.5" />
                      {fmt(v.duration_sec)}
                    </div>
                  </button>
                )}
              </div>
              <div className="p-4">
                <p className="arabic text-gold text-sm mb-1.5">{v.title_ar}</p>
                <h3 className="font-heading text-base text-forest font-semibold leading-snug mb-2">
                  {v.title_en}
                </h3>
                <a
                  href={`https://youtube.com/watch?v=${v.id}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`rec-youtube-${v.id}`}
                  className="inline-flex items-center gap-1 text-[11px] text-mute hover:text-clay transition"
                >
                  <Youtube className="w-3 h-3" />
                  Open in YouTube
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RuqyahRecommendation;
